// @flow

// Libs
import React from 'react'

// Messages
import { FormattedMessage } from 'react-intl'
import messages from 'hfty-datatable-recommendations/src/messages'

// Constants
import {
  SMALL_SIZE,
  MEDIUM_SIZE,
  LARGE_SIZE,
  SORT_AS_NUMBER,
  SORT_AS_BOOLEAN,
  SORT_AS_MIX,
} from 'fc-component-datatable'
import {
  ATTR_RECOMMENDATION_ID,
  ATTR_CROP,
  ATTR_YIELD_TARGET,
  ATTR_TARGET_PH,
  ATTR_RECOMMENDATION_TYPE,
  ATTR_CONTROLLER_TYPE,
  ATTR_ELEMENTS,
  ATTR_PRODUCTS,
  ATTR_MAP_REPORTS,
  ATTR_HAS_MAP_REPORTS,
  ATTR_CONTROLLER_FILES,
  ATTR_HAS_CONTROLLER_FILES,
} from './constants'

// Translate util
const translate = (column: Object): React.Element<any> => <FormattedMessage {...messages[column.attr]} />

// Columns config
export default [
  {
    attr: ATTR_RECOMMENDATION_ID,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_NUMBER,
  },
  {
    attr: ATTR_CROP,
    size: LARGE_SIZE,
    render: translate,
  },
  {
    attr: ATTR_YIELD_TARGET,
    size: MEDIUM_SIZE,
    render: translate,
    sortAs: SORT_AS_MIX,
  },
  {
    attr: ATTR_TARGET_PH,
    size: SMALL_SIZE,
    render: translate,
    sortAs: SORT_AS_NUMBER,
  },
  {
    attr: ATTR_RECOMMENDATION_TYPE,
    size: LARGE_SIZE,
    render: translate,
  },
  {
    attr: ATTR_CONTROLLER_TYPE,
    size: LARGE_SIZE,
    render: translate,
  },
  {
    attr: ATTR_ELEMENTS,
    size: SMALL_SIZE,
    render: translate,
    hideSorters: true,
  },
  {
    attr: ATTR_PRODUCTS,
    size: LARGE_SIZE,
    render: translate,
    hideSorters: true,
  },
  {
    attr: ATTR_MAP_REPORTS,
    size: SMALL_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_MAP_REPORTS,
  },
  {
    attr: ATTR_CONTROLLER_FILES,
    size: SMALL_SIZE,
    render: translate,
    allowFiltering: false,
    sortAs: SORT_AS_BOOLEAN,
    booleanAttr: ATTR_HAS_CONTROLLER_FILES,
  },
]
